import classNames from 'classnames';

import React, {PropsWithChildren} from 'react';

interface Props {
    className?: string;
}

export default function BolmateContent({className, children}: PropsWithChildren<Props>) {
    return (
        <div className={classNames('page', className)}>
            <div className='page-inner'>{children}</div>
        </div>
    );
}
